import {
  // Dashboard get All projects
  PROJECTS_REQUEST,
  PROJECTS_SUCCESS,
  PROJECTS_FAIL,
  // Project Rename
  RENAME_PROJECT_REQUEST,
  RENAME_PROJECT_SUCCESS,
  RENAME_PROJECT_FAIL,
  // Template
  TEMPLATE_REQUEST,
  TEMPLATE_SUCCESS,
  TEMPLATE_FAIL,   
  // Project Layout (Navbar / Sidebar / Preview / Options / Footer)
  PROJECT_REQUEST,
  PROJECT_SUCCESS,
  PROJECT_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELETE_FAIL,
  // Crdit Reload Action
  PROJECT_CREDITS_UPDATE_REQUEST,
  PROJECT_CREDITS_UPDATE_SUCCESS,
  PROJECT_CREDITS_UPDATE_FAIL,

  PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
  PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,

  CURRENT_BLOCK_UPDATE,
  UNDO_REDO_SET_STATE,
  
  // UploadLogo in Block
  PROJECT_LOGO_UPLOAD_SUCCESS,

  // Sidebar block move
  BLOCK_MOVE,
  // Setting Options
  PROJECT_OPTION_SUCCESS,  
  SETTING_OPTION_STATE,
  PROJECT_SETTINGS_UPDATE_SUCCESS,
  // FontStyles
  FONT_STYLE_UPDATE,
  PROJECT_FONTSTYLE_UPDATE_SUCCESS,
  // Render Export
  PROJECT_RENDER_REQUEST_SUCCESS,
  RENDER_DELETE_FAIL,
  RENDER_DELETE_SUCCESS,
  RENDER_DELETE_All_SUCCESS,
  RENDER_DELETE_ALL_FAIL,
  DOWNLOAD_RENDER_REQUEST,
} from "./types";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../../services/axios";
import store from "../store";
import UndoRedo from "../../UndoRedoClass";
import { toast } from "react-toastify";


const returnToastNotify = async (key, value) => {

  if (key === "double_columns" && (value || !value)) {
    const column = key === "double_columns" && value ? "Double Column Set" :
      key === "double_columns" && !value ? "Single Column Set" :
        "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (key === "name_on_left" && (value || !value)) {
    const name = key === "name_on_left" && value ? "Name Set On Left" :
      key === "name_on_left" && !value ? "Name Set On Right" :
        "";
    return toast.success("saving...", { autoClose: 300 });
  } else if (key === "block_inset" && (value === "default" || value === "left" || value === "right" || value === "sidebyside")) {
    const blockInset = `Block Inset Set ${value}`;
    return toast.success("saving...");
  } else if (key === "margin_vertical") {
    const margin = `Vertical Margin Set ${value} %`;
    return toast.success("saving...", { autoClose: 300 });
  }
};

export const getProjectDetails = (projectId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const response = await getRequest(`/project/${projectId}`);
    if (response?.data?.success) {
      const {
        credits,
        fontStyle,
        settings,
        members,
        logos,
        _id,
        googleSpreadSheetId,
        googleSheetLink,
        isVideoGenerated,
        renders,
        title
      } = response?.data?.project;

      dispatch({
        type: PROJECT_SUCCESS,
        payload: {
          _id,
          credits,
          fontStyle,
          settings,
          members,
          logos,
          googleSheetLink,
          googleSpreadSheetId,
          currentBlock: { idx: 0, id: credits[0]?._id },
          isVideoGenerated,
          renders,
          title
        },
      });
      const project = store.getState().project;
      const objectsMap = project.credits.map((credit, index) => {
        const obj = new UndoRedo();
        obj.push(credit.options);
        return { obj: obj, index: index };
      });
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
    } else {
      // handle unsuccessful response here
    }
    return response;
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error
  }
};

export const createProject = (data) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_CREATE_REQUEST });
    const { data: projectData } = await postRequest(`/project/`, data);
    const { project } = projectData;
    dispatch({
      type: PROJECT_CREATE_SUCCESS,
      payload: {
        project,
      },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_CREATE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const createAGoogleProject = (projectName, templateId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_CREATE_REQUEST });
    const projectRoute = process.env.REACT_APP_PROJECT_CREATE_ROUTE || 'byGoogle';
    const projectData = await postRequest(`/project/${projectRoute}`, {
      // title: `Google Project ${new Date().toDateString()}${Date.now()}`, //Will update it by user entered value
      title: projectName,
      templateId: templateId ? templateId : 0
    });
    const { project } = projectData?.data
    if (project) {
      dispatch({
        type: PROJECT_CREATE_SUCCESS,
        payload: {
          project,
        },
      });
      return projectData?.data;
    } else {
      return projectData.response.data
    }

  } catch (error) {
    dispatch({
      type: PROJECT_CREATE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    return error;
  }
};

export const deleteRenders = (projectId, renderId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const response = await deleteRequest(
      `/project/deleteOneRender/${projectId}/${renderId}`
    );
    if (response?.data?.success) {
      dispatch({
        type: RENDER_DELETE_SUCCESS,
        payload: { renderId: response?.data?.RenderId },
      });
    } else {
      dispatch({
        type: RENDER_DELETE_FAIL,
        payload: {
          error: response?.data?.error,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
//delete all render
export const deleteAllRenders = (projectId,) => async (dispatch) => {   
  try {
    dispatch({ type: PROJECT_REQUEST });
    const response = await deleteRequest(
      `/project/deleteAllRenders/${projectId}`
    );
    if (response?.data?.success) {
      dispatch({
        type: RENDER_DELETE_All_SUCCESS,
        payload: { deleterenders: response?.data?.renders },
      });
      return response?.data
    } else {
      dispatch({
        type: RENDER_DELETE_ALL_FAIL,
        payload: {
          error: response?.data?.error,
        },
      });
      return response?.data
    }
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const deleteAProject = (projectId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_DELETE_REQUEST });
    const { data: projectData } = await deleteRequest(`/project/${projectId}`);
    dispatch({
      type: PROJECT_DELETE_SUCCESS,
      payload: { projectId: projectData.projectId },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_DELETE_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const updateProjectCreditOptionsState =
  (creditsIdx, optionKey, optionValue) => async (dispatch) => {
    dispatch({
      type: PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
      payload: {
        creditsIdx,
        optionKey,
        optionValue,
      },
    });
    // returnToastNotify(optionKey, optionValue)
  };

export const updateCurrentBlockState = (id, idx) => async (dispatch) => {
  dispatch({
    type: CURRENT_BLOCK_UPDATE,
    payload: {
      id,
      idx,
    },
  });
};

// updateSettingOptionState
export const updateSettingOptionState =
  (settingsKey, settingsvalue) => async (dispatch) => {
    dispatch({
      type: SETTING_OPTION_STATE,
      payload: {
        settingsKey,
        settingsvalue,
      },
    });
  };

export const saveProjectSettings = () => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    let { _id: projectId, settings } = store.getState().project;
    if (settings.variant === null || settings.variant === undefined) settings.variant = " "
    delete settings._id;
    const { data } = await putRequest(
      `/project/${projectId}/settings/`,
      settings
    );

    dispatch({
      type: PROJECT_SETTINGS_UPDATE_SUCCESS,
      payload: {
        settings: data.settings,
      },
    });
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const updateFontStyleState =
  (key, property, value, currentBlockType) => async (dispatch) => {
    if (currentBlockType === "nameonly" && key === "name") {
      key = "nameOnlyStyle";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: {
          key,
          property,
          value,
        },
      });
    }
    else if (
      currentBlockType === "rolename" && (key === "name" || key === "role") &&
      (property === "lineHeight")
    ) {
      key = "role";
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: {
          key,
          property,
          value,
        },
      });
    }
    else {
      dispatch({
        type: FONT_STYLE_UPDATE,
        payload: {
          key,
          property,
          value,
        },
      });
    }
  };

export const saveOptionById = (creditsId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });

    if (!creditsId) throw Error("Error: no current options id to save");

    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const options = credits[idx].options;

    const { data } = await putRequest(
      `/project/${projectId}/credits/${creditsId}/options`,
      options
    );
    if (data?.success) {
      dispatch({
        type: PROJECT_OPTION_SUCCESS,
        payload: {
          options: data?.options,
          creditsId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
export const saveFontStyle =
  (fontStyleType, currentBlockType, key, value, notifyWithToast) => async (dispatch) => {

    try {
      dispatch({ type: PROJECT_REQUEST });
      let { _id: projectId, fontStyle } = store.getState().project;
      const fontStylePreBody = fontStyle?.fontStyleBody
      fontStyle = fontStyle[fontStyleType];
      const { _id, ...newFontStyle } = fontStyle;
      if (fontStylePreBody === "undefined" || JSON.stringify(fontStylePreBody) !== JSON.stringify(fontStyle)) {
        const { data } = await putRequest(
          `/project/${projectId}/fontStyle/${fontStyleType}`,
          newFontStyle
        );
        if (data?.success) {
          dispatch({
            type: PROJECT_FONTSTYLE_UPDATE_SUCCESS,
            payload: {
              fontStyle: data.fontStyle,
              fontStyleType,
              fontStyleBody: fontStyle
            },
          });
          //  return notifyWithToast({ keyName: key, value ,data:data?.success})

        }
      }

    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const updateProjectCredits =
  (projectId, credits) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      const { data } = await putRequest(`/project/${projectId}/credits/`, {
        credits,
      });

      dispatch({
        type: PROJECT_CREDITS_UPDATE_SUCCESS,
        payload: {
          credits: data.credits,
        },
      });
      const project = store.getState().project;
      const objectsMap = project.credits.map((credit, index) => {
        const obj = new UndoRedo();
        obj.push(credit.options);
        return { obj: obj, index: index };
      });
      dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };
// RELOAD
export const updateProjectCreditsByGoogle =
  (projectId, spreadsheetId, credit) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_CREDITS_UPDATE_REQUEST });
      const data = await putRequest(`/project/${projectId}/credits/byGoogle`,  {credit, projectId, spreadsheetId,});
      // console.log('Data === ', data);

      
      // const prevProject = store.getState().project;
      // const currentBlock = prevProject?.currentBlock;
      if (data?.data?.success) {
        // if (data?.project?._id === prevProject?._id) {
        //   const updatedCredits = credits?.map((item1, index) => {
        //     if (prevProject?.credits[index] && prevProject?.credits[index]?.options) {
        //       return { ...item1, options: prevProject?.credits[index].options };
        //     }
        //     return item1;
        //   });
        //   credits = updatedCredits
        // }

        let {
          credits,
          fontStyle,
          settings,
          members,
          logos,
          _id,
          googleSpreadSheetId,
          googleSheetLink,
          isVideoGenerated,
          renders,
          title,
        } = data?.data?.project;

        dispatch({
          type: PROJECT_CREDITS_UPDATE_SUCCESS,
          payload: {
            _id,
            credits,
            fontStyle,
            settings,
            members,
            logos,
            googleSheetLink,
            googleSpreadSheetId,
            currentBlock: { idx: 0, id: credits[0]?._id },
            isVideoGenerated,
            renders,
            title
          },
        });
        const project = store.getState().project;

        const objectsMap = project.credits.map((credit, index) => {
          const obj = new UndoRedo();
          obj.push(credit.options);
          return { obj: obj, index: index };
        });

        dispatch({ type: UNDO_REDO_SET_STATE, payload: objectsMap });
        return data?.data
      }else{
        return data;
      }

    } catch (error) {
      dispatch({
        type: PROJECT_CREDITS_UPDATE_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const updateAProjectCreditItemsState =
  (creditsId, items) => (dispatch) => {
    dispatch({
      type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
      payload: {
        items,
        creditsId,
      },
    });
  };

export const updateProjectCreditItems =
  (creditsId, items) => async (dispatch) => {
    try {
      dispatch({ type: PROJECT_REQUEST });
      const { _id: projectId } = store.getState().project;
      const { data } = await putRequest(
        `/project/${projectId}/credits/${creditsId}/items`,
        {
          items,
        }
      );
      dispatch({
        type: PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
        payload: {
          items: data.items,
          creditsId,
          dataSaved: true,
        },
      });
    } catch (error) {
      dispatch({
        type: PROJECT_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const uploadLogoDetails = (filedata,creditID) => async (dispatch) => {
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const { _id: projectId } = store.getState().project;
    const response = await postRequest(`/project/${projectId}/${creditID}/logoUpload`, filedata);
    if (response?.data?.success) {
      dispatch({
        type: PROJECT_LOGO_UPLOAD_SUCCESS,
        payload: {
          logos:response?.data?.uploadedLogos
        },
      });
      return response?.data 
    } else {
      const { data } = response.response;
      const { error: message, success } = data;
      return {message,success}
    }
  
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    if (error.response && error.response.data) {
      const { data } = error.response;
      const { error: message, success } = data;
      return { message, success }
    }
  }
};

export const requestRenderXVideo = (images, reqBody) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const formData = new FormData();
    images.forEach((image) =>
      formData.append("preview", image.blob, `preview-${image.idx + 1}`)
    );
    Object.keys(reqBody).forEach((key) => formData.append(key, reqBody[key]));
    const { _id: projectId } = store.getState().project;
    const { data } = await postRequest(`/renderx/${projectId}/`, formData);
    dispatch({
      type: PROJECT_RENDER_REQUEST_SUCCESS,
      payload: { renders: data.renders },
    });
    return data
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const cloneProject = (sourceProjectId, title) => async (dispatch) => {
  try {
    dispatch({ type: PROJECTS_REQUEST });
    const responseData = await postRequest("/project/clone", {
      sourceProjectId,
      title,
    });
    const { project } = responseData?.data;
    if (responseData?.data?.success) {
      dispatch({
        type: PROJECT_CREATE_SUCCESS,
        payload: {
          project,
        },
      });
      return responseData;
    } else {
      return responseData;
    }
  } catch (error) {
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const undoOptions = (creditsId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });

    if (!creditsId) throw Error("Error: no current options id to save");
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;

    const options = obj.getPreviousState;
    //setting state optimisticly
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    const { data } = await putRequest(
      `/project/${projectId}/credits/${creditsId}/options`,
      options
    );
    //experimenting
    /*dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: data.options,
        creditsId,
      },
    });*/
  } catch (error) {
    //reverting state
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;
    const options = obj.getNextState;
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
export const redoOptions = (creditsId) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });

    if (!creditsId) throw Error("Error: no current options id to save");
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;

    const options = obj.getNextState;
    //setting state optimisticly
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    const { data } = await putRequest(
      `/project/${projectId}/credits/${creditsId}/options`,
      options
    );
    //Experimenting
    /*dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: data.options,
        creditsId,
      },
    });*/
  } catch (error) {
    //reverting state
    const { credits, _id: projectId } = store.getState().project;
    const idx = credits.findIndex((credit) => credit._id == creditsId);
    if (idx == -1) throw Error("Error in saving options");
    const obj = store.getState().undoRedo[idx].obj;
    const options = obj.getPreviousState;
    dispatch({
      type: PROJECT_OPTION_SUCCESS,
      payload: {
        options: options,
        creditsId,
      },
    });
    dispatch({
      type: PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};
//drag and drop action
export const moveBlock = (sourceIdx, targetIdx) => async (dispatch) => {
  dispatch({
    type: BLOCK_MOVE,
    payload: {
      sourceIdx,
      targetIdx,
    },
  });
};

// download render video link 

export const downloadRender = (projectId, renderId) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_RENDER_REQUEST });
    const response = await getRequest(`/renderx/${projectId}/${renderId}`);
    return response?.data;
  } catch (error) {
    dispatch({
      type: RENDER_DELETE_ALL_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};


// rename project

export const renameProject = (projectId, projectName) => async (dispatch) => {
  try {
    dispatch({ type: PROJECT_REQUEST });
    const update_response = await putRequest(`/project/updateTitle/${projectId}`, {
      name: projectName,
    });
    const { updatedProject } = update_response?.data;
    dispatch({
      type: RENAME_PROJECT_SUCCESS,
      payload: {
        updatedProject,
      },
    });
    return update_response?.data;
  } catch (error) {
    dispatch({
      type: RENAME_PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Update Project Status

export const updateProjectStatus = (projectId, projectStatus,idx) => async (dispatch) => {

  try {
    dispatch({ type: RENAME_PROJECT_REQUEST });
    const updateStatusResponse = await putRequest(`/project/updateProjectStatus/${projectId}`, { projectStatus: projectStatus ,statusId:idx});
    const { updatedProject } = updateStatusResponse?.data;
    dispatch({
      type: RENAME_PROJECT_SUCCESS,
      payload: { updatedProject }
    })
  } catch (error) {
    dispatch({
      type: RENAME_PROJECT_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
}






